var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor-grafica-aavv"},[_c('div',{attrs:{"id":"chartdivaavv"}}),_c('article',{staticClass:"stat -small"},[_c('strong',[_c('count-to',{attrs:{"endVal":_vm.total,"separator":"."}})],1),_c('span',[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }